import { isFn } from './checkers';
import { batchStart, batchEnd, batchScopeStart, batchScopeEnd, } from './reaction';
import { createAnnotation } from './internals';
import { MakeObservableSymbol } from './environment';
var createBatchAnnotation = function (method) {
    return createAnnotation(function (_a) {
        var target = _a.target, key = _a.key, value = _a.value;
        var action = function (callback) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return method(function () {
                    return isFn(callback) ? callback.apply(target, args) : undefined;
                });
            };
        };
        if (target) {
            target[key] = action(target[key]);
            return target;
        }
        return action(value);
    });
};
export var batch = function (callback) {
    var result = null;
    try {
        batchStart();
        if (isFn(callback)) {
            result = callback();
        }
    }
    finally {
        batchEnd();
    }
    return result;
};
export var action = createBatchAnnotation(batch);
batch.scope = function (callback) {
    var result = null;
    try {
        batchScopeStart();
        if (isFn(callback)) {
            result = callback();
        }
    }
    finally {
        batchScopeEnd();
    }
    return result;
};
batch[MakeObservableSymbol] = action;
batch.scope[MakeObservableSymbol] = createBatchAnnotation(batch.scope);
